import React, { Fragment } from 'react';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

const navItems = [
  {
    path: '/admin/receivements',
    label: _ => '入庫処理',
  },
  {
    path: '/admin/unknownInventories',
    label: _ => '不明入庫',
  },
  {
    path: '/admin/shippings',
    label: _ => '出荷処理',
  },
  {
    path: '/admin/combinings',
    label: _ => 'セット処理',
  },
];

export default function TenantBottomNav (props) {
  const { location, ...extraProps } = props;

  return (
    <div className={classnames('overflow-auto position-fixed bg-dark px-2 py-3 bottom-nav d-flex')} style={{ zIndex: 1000, height: 60, right: 0, bottom: 0, left: 0, }} {...extraProps}>
      <ul className="w-100 nav nav-pills flex-nowrap justify-content-around">
        {
          navItems.map(({ path, label, }) => {
            return (
              <li className="nav-item" key={path}>
                <Link to={path} className={classnames('nav-link d-flex flex-column text-white align-items-center', { active: location.pathname === path })}>
                  <span className="text-nowrap" style={{ fontSize: '45%' }}>
                    {label(props)}
                  </span>
                </Link>
              </li>
            );
          })
        }
      </ul>
    </div>
  );
};
